import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bodyAreas, productName, showcaseFeatures } from '../data/content';
import { Eyebrow } from './ui/Section';
export function ProductShowcase() {
  return <section className="bg-slate-50 px-4 py-12 md:py-16" data-id="element-200" data-mp="32lkybzr0zrgz">
      <div className="mx-auto max-w-4xl text-center" data-id="element-201" data-mp="32n5utuwwhkhh">
        <Eyebrow data-id="element-202" data-mp="2xn9se03uq141">The complete 5-volume system</Eyebrow>
        <h2 className="text-2xl font-black uppercase leading-tight text-brand-deep md:text-3xl" data-id="element-203" data-mp="29wnu30jnfv78">{productName}</h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm font-semibold leading-relaxed text-slate-600 md:text-base" data-id="element-204" data-mp="24y2riugxczfm">
          Designed for physiotherapists, physical therapists, qualified manual therapists, and rehabilitation
          professionals.
        </p>
        <ul className="mt-4 flex flex-wrap justify-center gap-x-2 gap-y-1 text-xs font-bold uppercase tracking-wide text-brand" data-id="element-205" data-mp="2extnl0l4vmht">
          {bodyAreas.map((area, index) => <li key={area} className="flex items-center gap-2" data-id="element-206" data-mp="3qa4a4p9aamdt" data-mpi={index}>
              {index > 0 && <span className="text-brand/30" aria-hidden="true" data-id="element-207" data-mp="249e0rmpizwvj">
                  •
                </span>}
              {area}
            </li>)}
        </ul>

        <ul className="mt-8 grid gap-2.5 text-left sm:grid-cols-2" data-id="element-208" data-mp="2e9ep5n29536l">
          {showcaseFeatures.map(item => <li key={item} className="flex items-center gap-3 rounded-xl border border-brand/10 bg-white px-4 py-2.5 text-sm font-semibold text-brand-deep" data-id="element-209" data-mp="2i9f02xq56w8w">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand" data-id="element-210" data-mp="1qjajla5i6tcy">
                <CheckIcon className="h-3 w-3 text-gold-light" aria-hidden="true" data-id="element-211" data-mp="1uit1dx212obk" />
              </span>
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}